
import React, { Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../config/AuthContext';

import DashboardLayout from '@/components/layout/DashboardLayout';
import DashboardHome from '@/pages/DashboardHome';
import PurchaseOrder from '@/pages/PurchaseOrder';
import SalesOrder from '@/pages/SalesOrder';
import Login from '@/pages/Login';
import LoadPlan from '@/pages/LoadPlan';
// import AuthInitializer from '@/pages/AuthInitializer';
import Shipment from '@/pages/Shipment';
import Mailbox from '@/pages/Mailbox';
import EmailSummaryDashboard from '@/pages/EmailSummaryDashboard';
import RateIntelligence from '@/pages/RateIntelligenceAgent';
import QuotesBookings from '@/pages/QuotesBookings';
import CustomsFiling from '@/pages/CustomsFiling';
import ContainerTrackingPage from '@/pages/ContainerTrackingPage';
import Financials from '@/pages/Financials';
import Booking from '@/pages/Booking';
import BookingPrint from '@/components/booking/BookingPrint';
import RateMatrix from '@/pages/RateMatrix';
import OceanControlTower from '@/pages/OceanControlTower';
import QuotationReport from '@/pages/QuotationReport';
import BookingReport from '@/pages/BookingReport';
import AccountingReport from '@/pages/AccountingReport';
import HBL from '@/pages/HBL';
import MBL from '@/pages/MBL';
import StatusAudit from '@/pages/StatusAudit';
import AddressBooking from '@/pages/AddressBook';
import VisionBoard from '@/pages/VisionBoard';
import RFQ from '@/pages/RFQ';
import AIAgentSetup from '@/pages/AIAgentSetup';
import AIAgentDashboard from '@/pages/AIAgentDashboard';
import AIAgentReports from '@/pages/AIAgentReports';

import RateQuote from '@/pages/RateQuote';
import NewRateQuote from '@/pages/RateQuote/NewRateQuote';
import RateQuotePrint from '@/pages/RateQuote/RateQuotePrint';
import HBLPrint from '@/components/HBL/HBLPrint';
import MBLPrint from '@/components/MBL/MBLPrint';
import MaintainVessels from '@/pages/Vessel/MaintainVessel';
import VesselModal from '@/pages/Vessel/VesselModal';
import Commodity from '@/pages/Commodity';

import ComposeMail from '@/pages/Mail/ComposeMail';
import CountryClause from '@/pages/CountryClause';
import MaintainClause from '@/pages/Clause';
import MaintainUsers from '@/pages/Users';
import ChargesCode from '@/pages/ChargesCode';
import PrintAuditStatusPgae from '@/pages/PrintAuditStatusPgae';
import DockReceipt from '@/pages/DockReceipt/DockReceipt';
import NotificationCenterPage from '@/pages/NotificationCenterPage';
import DockReceiptPrint from '@/pages/DockReceipt/DockReceiptPrint';

import JobCosting from '@/pages/JobCosting';

// Quote Response Page (Public - accessible from email)
import QuoteResponse from '@/pages/QuoteResponse';

// Signup Pages (Public)
import SignupWizard from '@/pages/SignupWizard';
import SignupSuccess from '@/pages/SignupSuccess';

// Accounting Module
import ChartOfAccounts from '@/pages/Accounting/ChartOfAccounts';
import AccountingChargeCodes from '@/pages/Accounting/ChargeCodes';
import VendorBills from '@/pages/Accounting/VendorBills';
import JournalEntries from '@/pages/Accounting/JournalEntries';
import Payments from '@/pages/Accounting/Payments';
import AccountingReports from '@/pages/Accounting/Reports';
import PortPlace from '@/pages/PortPlace/PortPlace';
import MaintainLocations from '@/pages/MaintainLocations/MaintainLocations';

// Ocean Import Module
import {
    ImportRateQuoteList, ImportRateQuoteForm, ImportBookingList, ImportBookingForm,
    ReleaseOrderList, ReleaseOrderForm, DeliveryOrderForm, BookingImportPrintNonFreight
} from '@/pages/OceanImport';
import ImportStatusAudit from '@/pages/OceanImport/ImportBooking/ImportStatusAudit';
import ImportPrintAuditStatusPgae from '@/pages/OceanImport/ImportBooking/PrintAudit/PrintAuditStatusPgae';

import ImportHBLPrint from '@/components/ImportPrint/importHBLPrint';
import ISFPrint from '@/components/ImportPrint/ISFPrint';
import CustomerInvoices from '@/pages/Accounting/Invoice/CustomerInvoices';
import ImportRateQuotePrint from '@/pages/OceanImport/RateQuote/ImportRateQuotePrint';

// Admin Panel
import AdminPanel from '@/pages/AdminPanel';
import BookingImportPrint from '@/pages/OceanImport/ImportBooking/BookingImportPrint';
//
import CancelShipmentList from '@/pages/Shipment/CancelShipmentList';
import CancelShipment from '@/pages/Shipment/CancelShipment';
import BookingRequestList from '@/pages/BookingRequest/BookingRequestList';
import NewBookingRequest from '@/pages/BookingRequest/NewBookingRequest';
import AdminLogin from '@/pages/superAdmin/Login';
import ReleaseOrderPrint from '@/pages/OceanImport/ImportBooking/ReleaseOrderPrint';
import DeliveryOrderPrint from '@/pages/OceanImport/ImportBooking/DeliveryOrderPrint';
const MainRoutes = () => {
    const { isAuthenticated } = useAuth();

    return (
        <Routes>
            {isAuthenticated ?
                <>
                    <Route path="/dashboard" element={<DashboardLayout><DashboardHome /></DashboardLayout>} />
                    <Route path="/purchase-orders" element={<DashboardLayout><PurchaseOrder /></DashboardLayout>} />
                    <Route path="/sales-orders" element={<DashboardLayout><SalesOrder /></DashboardLayout>} />
                    <Route path="/load-plan" element={<DashboardLayout><LoadPlan /></DashboardLayout>} />
                    <Route path="/ShipmentList" element={<DashboardLayout><Shipment /></DashboardLayout>} />
                    <Route path="/mailbox" element={<DashboardLayout><Mailbox /></DashboardLayout>} />
                    <Route path="/vision-board" element={<DashboardLayout><VisionBoard /></DashboardLayout>} />
                    <Route path="/email-summary" element={<DashboardLayout><EmailSummaryDashboard /></DashboardLayout>} />
                    <Route path="/ratematrix" element={<DashboardLayout><RateMatrix /></DashboardLayout>} />
                    <Route path="/ocean-control-tower" element={<DashboardLayout><OceanControlTower /></DashboardLayout>} />

                    {/* Booking request */}
                    <Route path="/booking-request-list" element={<DashboardLayout><BookingRequestList /></DashboardLayout>} />
                    <Route path="/booking-request/new" element={<DashboardLayout><NewBookingRequest /></DashboardLayout>} />
                    <Route path="/booking-request/edit/:id" element={<DashboardLayout><NewBookingRequest /></DashboardLayout>} />
                    {/* <Route path="/booking-request/print/:id" element={<RateQuotePrint />} /> */}

                    {/* Booking */}

                    <Route path="/booking" element={<DashboardLayout><Shipment /></DashboardLayout>} />
                    <Route path="/booking/cancel" element={<DashboardLayout><CancelShipment /></DashboardLayout>} />
                    <Route path="/booking/print/:id" element={<BookingPrint />} />



                    {/* Address Book */}
                    <Route path="/address-book" element={<DashboardLayout><AddressBooking /></DashboardLayout>} />

                    {/* AI Insights submenu routes */}
                    <Route path="/rate-intelligence" element={<DashboardLayout><RateIntelligence /></DashboardLayout>} />
                    <Route path="/quotes-bookings" element={<DashboardLayout><QuotesBookings /></DashboardLayout>} />
                    <Route path="/customs" element={<DashboardLayout><CustomsFiling /></DashboardLayout>} />
                    <Route path="/containers" element={<DashboardLayout><ContainerTrackingPage /></DashboardLayout>} />
                    <Route path="/financials" element={<DashboardLayout><Financials /></DashboardLayout>} />

                    {/* Reports submenu routes */}
                    <Route path="/quotation-report" element={<DashboardLayout><QuotationReport /></DashboardLayout>} />
                    <Route path="/booking-report" element={<DashboardLayout><BookingReport /></DashboardLayout>} />
                    <Route path="/accounting-report" element={<DashboardLayout><AccountingReport /></DashboardLayout>} />

                    {/* OCEAN submenu routes */}
                    <Route path="/rate-quote" element={<DashboardLayout><RateQuote /></DashboardLayout>} />
                    <Route path="/rate-quote/new" element={<DashboardLayout><NewRateQuote /></DashboardLayout>} />
                    <Route path="/rate-quote/edit/:id" element={<DashboardLayout><NewRateQuote /></DashboardLayout>} />
                    <Route path="/rate-quote/print/:id" element={<RateQuotePrint />} />

                    {/* HBL & MBL routes */}
                    <Route path="/hbl" element={<DashboardLayout><HBL /></DashboardLayout>} />
                    <Route path="/hblPrint" element={<DashboardLayout><HBLPrint /></DashboardLayout>} />
                    <Route path="/mbl" element={<DashboardLayout><MBL /></DashboardLayout>} />
                    <Route path="/mblPrint" element={<DashboardLayout><MBLPrint /></DashboardLayout>} />
                    {/* Status Audit route */}
                    <Route path="/status-audit" element={<DashboardLayout><StatusAudit /></DashboardLayout>} />

                    {/* RFQ route */}
                    <Route path="/rfq" element={<DashboardLayout><RFQ /></DashboardLayout>} />

                    {/* AI Agent routes */}
                    <Route path="/ai-agent-setup" element={<DashboardLayout><AIAgentSetup /></DashboardLayout>} />
                    <Route path="/ai-agent-dashboard" element={<DashboardLayout><AIAgentDashboard /></DashboardLayout>} />
                    <Route path="/ai-agent-reports" element={<DashboardLayout><AIAgentReports /></DashboardLayout>} />
                    <Route path="/maintain-vessel" element={<DashboardLayout><MaintainVessels /></DashboardLayout>} />

                    {/* Booking */}
                    <Route path="/Commodity" element={<DashboardLayout><Commodity /></DashboardLayout>} />

                    {/* Mail Compose */}
                    <Route path="/mail/compose" element={<DashboardLayout><ComposeMail /></DashboardLayout>} />

                    {/* System Maintenance */}
                    <Route path="/CountryClause" element={<DashboardLayout><CountryClause /></DashboardLayout>} />
                    <Route path="/Clause" element={<DashboardLayout><MaintainClause /></DashboardLayout>} />
                    <Route path="/ChargesCode" element={<DashboardLayout><ChargesCode /></DashboardLayout>} />
                    <Route path="/status-audit/print" element={<PrintAuditStatusPgae />} />
                    <Route path="/port-place" element={<DashboardLayout><PortPlace /></DashboardLayout>} />
                    <Route path="/Users" element={<DashboardLayout><MaintainUsers /></DashboardLayout>} />

                    {/* Notification Center */}
                    <Route path="/notifications" element={<DashboardLayout><NotificationCenterPage /></DashboardLayout>} />
                    <Route path="/dock-receipt/:bookingId" element={<DashboardLayout><DockReceipt /></DashboardLayout>} />
                    <Route path="/dock-receipt/print/:bookingId" element={<DockReceiptPrint />} />

                    {/* Job Costing */}
                    <Route path="/job-costing/:bookingId" element={<DashboardLayout><JobCosting /></DashboardLayout>} />

                    {/* Accounting Module */}
                    <Route path="/accounting" element={<DashboardLayout><ChartOfAccounts /></DashboardLayout>} />
                    <Route path="/accounting/chart-of-accounts" element={<DashboardLayout><ChartOfAccounts /></DashboardLayout>} />
                    <Route path="/accounting/charge-codes" element={<DashboardLayout><AccountingChargeCodes /></DashboardLayout>} />
                    <Route path="/accounting/invoices" element={<DashboardLayout><CustomerInvoices /></DashboardLayout>} />
                    <Route path="/accounting/bills" element={<DashboardLayout><VendorBills /></DashboardLayout>} />
                    <Route path="/accounting/journals" element={<DashboardLayout><JournalEntries /></DashboardLayout>} />
                    <Route path="/accounting/payments" element={<DashboardLayout><Payments /></DashboardLayout>} />
                    <Route path="/accounting/reports" element={<DashboardLayout><AccountingReports /></DashboardLayout>} />
                    <Route path="/maintain-locations" element={<DashboardLayout><MaintainLocations /></DashboardLayout>} />

                    {/* Ocean Import Module */}
                    <Route path="/import-rate-quote" element={<DashboardLayout><ImportRateQuoteList /></DashboardLayout>} />
                    <Route path="/import-rate-quote/new" element={<DashboardLayout><ImportRateQuoteForm /></DashboardLayout>} />
                    <Route path="/import-rate-quote/edit/:id" element={<DashboardLayout><ImportRateQuoteForm /></DashboardLayout>} />
                    <Route path="/import-rate-quote/print/:id" element={<ImportRateQuotePrint />} />

                    <Route path="/import-booking" element={<DashboardLayout><ImportBookingList /></DashboardLayout>} />
                    <Route path="/import-booking/new" element={<DashboardLayout><ImportBookingForm /></DashboardLayout>} />
                    <Route path="/import-booking/edit/:id" element={<DashboardLayout><ImportBookingForm /></DashboardLayout>} />
                    <Route path="/import-booking/Print/:id" element={<BookingImportPrint />} />
                    <Route path="/import-booking/PrintNonFreight/:id" element={<BookingImportPrintNonFreight />} />
                    <Route path="/release-order" element={<DashboardLayout><ReleaseOrderList /></DashboardLayout>} />
                    <Route path="/release-order/new" element={<DashboardLayout><ReleaseOrderForm /></DashboardLayout>} />
                    <Route path="/release-order/edit" element={<DashboardLayout><ReleaseOrderForm /></DashboardLayout>} />
                    <Route path="/release-order/print/:id" element={<ReleaseOrderPrint />} />
                    <Route path="/delivery-order/new" element={<DashboardLayout><DeliveryOrderForm /></DashboardLayout>} />
                    <Route path="/delivery-order/edit/:id" element={<DashboardLayout><DeliveryOrderForm /></DashboardLayout>} />
                    <Route path="/delivery-order/print/:id" element={<DeliveryOrderPrint />} />
                    <Route path="/import-booking/status-audit/:id" element={<DashboardLayout><ImportStatusAudit /></DashboardLayout>} />
                    <Route path="/import-status-audit/print/:companyId/:bookingId" element={<ImportPrintAuditStatusPgae />} />
                    <Route path="/import-hbl-print/:bookingId" element={<DashboardLayout><ImportHBLPrint /></DashboardLayout>} />
                    <Route path="/import-isf-print/:bookingId" element={<DashboardLayout><ISFPrint /></DashboardLayout>} />
                    {/* Admin Panel */}
                    <Route path="/admin" element={<DashboardLayout><AdminPanel /></DashboardLayout>} />
                </>
                :
                <>

                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Navigate to="/login" replace />} />
                </>


            }
            {/* Locker Freight Login demo logn path*/}
            <Route path="/locker-freight/login" element={<Login />} />
            {/* Admin Panel */}
            <Route path="/adminLogin" element={<AdminLogin />} />
            {/* Public Routes (accessible without authentication) */}
            <Route path="/quote-response" element={<QuoteResponse />} />
            <Route path="/signup" element={<SignupWizard />} />
            <Route path="/signup/success" element={<SignupSuccess />} />
            <Route path="*" element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/" />} />
        </Routes>
    );
};

export default MainRoutes;
